<div
  class="text-field df-c"
  [ngClass]="{
    'text-field--error': isInvalidShown(),
    'text-field--filled': isFilled(),
    'text-field--disabled': disabled(),
    'text-field--size-small': size() === 'small',
  }"
>
  @if (label()) {
    <span class="text-field__label">
      {{ label() }}
      @if (required()) {
        <span class="text-field__label-required">*</span>
      }
    </span>
  }

  <div class="text-field__field">
    @if (leftText()) {
      <span class="text-field__field-leftText">{{ leftText() }}</span>
    }

    <input
      #input
      type="text"
      [value]="rawValue()"
      [placeholder]="placeholder() | translate"
      [disabled]="disabled()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (beforeinput)="onBeforeInput($event)"
    />

    @if (rightText()) {
      <span class="text-field__field-rightText">{{ rightText() }}</span>
    }
  </div>

  @if (isErrorVisible() && errorMessage(); as message) {
    <div class="text-field__error">
      <span>{{ message.key | translate: { value: message.value } }}</span>
    </div>
  }
</div>
